import { path } from "./patientsPath";

import type { ILoaderData as IPatientLoaderData } from "@pages/panelPages/userManagement/patient/patientForm";
import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";
import type { IRole } from "@/interfaces";

const permissions: IRole[] = [
  "staff",
  "admin",
  "doctor",
  "local-admin",
  "super-admin",
];

export const patientsRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.patient.route,
      lazy: () =>
        import("@pages/panelPages/userManagement/patient/patientList"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.patientManagement", [], "index", "main");
        return {};
      },
    },
    permissions,
  },
  {
    route: {
      path: path.patientView.route,
      lazy: () =>
        import("@pages/panelPages/userManagement/patient/patientForm"),
      loader: ({ params, request }): IPatientLoaderData => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.patientView",
          [
            {
              title: "pageTitle.patientManagement",
              url: path.patient.link(),
            },
          ],
          "view",
        );
        return { mode: "view", id: params.id! };
      },
    },
    permissions,
  },
  {
    route: {
      path: path.patientEdit.route,
      lazy: () =>
        import("@pages/panelPages/userManagement/patient/patientForm"),
      loader: ({ params, request }): IPatientLoaderData => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.patientEdit",
          [
            {
              title: "pageTitle.patientManagement",
              url: path.patient.link(),
            },
          ],
          "edit",
        );
        return { mode: "edit", id: params.id! };
      },
    },
    permissions,
  },
  {
    route: {
      path: path.patientCreate.route,
      lazy: () =>
        import("@pages/panelPages/userManagement/patient/patientForm"),
      loader: ({ request }): IPatientLoaderData => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.patientCreate",
          [
            {
              title: "pageTitle.patientManagement",
              url: path.patient.link(),
            },
          ],
          "create",
        );
        return { mode: "create" };
      },
    },
    permissions,
  },
  {
    route: {
      path: path.changePassword.route,
      lazy: () =>
        import("@pages/panelPages/changeUsersPassword/changeUsersPassword"),
      loader: ({ params, request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.changePassword", [], "index");
        return { role: params.role, id: params.id };
      },
    },
    permissions,
  },
];
